import * as React from "react";
import { IPortalSdk, IVendorData } from "./main";

const sdkContext = React.createContext<IPortalSdk>({} as any);

export type SdkProviderProps = {
  sdk: any;
  children: React.ReactNode;
};

export const SdkProvider = ({ sdk, children }: SdkProviderProps) => <sdkContext.Provider value={ sdk }>
  { children }
</sdkContext.Provider>

export type SdkProps = { sdk: IPortalSdk; };
export type OptionalSdkProps = { sdk?: IPortalSdk; };

export function useSdk() {
  return React.useContext<IPortalSdk>(sdkContext);
}

export function withSdk<T extends OptionalSdkProps>(Component: React.ComponentType<T>): React.ComponentType<T> {
  return (props: T) => {
    const sdk = useSdk();
    return < Component {...props } sdk = { sdk } />
  };
}

export function useSelectedVendors() {
  const sdk = useSdk();
  const [selectedVendors, setSelectedVendors] = React.useState<IVendorData[]>();  
  React.useEffect(() => sdk.addSelectedVendorsObserver(setSelectedVendors), []);
  return selectedVendors;
}

export function useCurrentVendor() {
  const sdk = useSdk();
  const [currentVendor, setCurrentVendor] = React.useState<IVendorData>();  
  React.useEffect(() => sdk.addVendorObserver(setCurrentVendor), []);
  return currentVendor;
}
